import { AppointmentListMini } from "@/pages/calendar/components/AppointmentListMini";

export function CalendarTab({ id, name }: { id: string; name: string }) {
  return (
    <AppointmentListMini
      relatedEntityType="SpvPool"
      relatedEntityId={id}
      entityLabel={name}
    />
  );
}
